import React from 'react'
import SecondaryInventoryPreviewTemplate from '../../templates/SecondaryInventory/SecondaryInventoryPreview.template'

const SecondaryInventoryView = () => {
  return (
    <SecondaryInventoryPreviewTemplate />
  )
}
export default SecondaryInventoryView